import React from 'react';
import { Search } from 'lucide-react';
import { BlogPost } from '@/data/blogPosts';
import BlogPostCard from './BlogPostCard';

interface BlogGridProps {
  posts: BlogPost[];
  showFeatured?: boolean;
  emptyMessage?: string;
}

const BlogGrid: React.FC<BlogGridProps> = ({
  posts,
  showFeatured = true,
  emptyMessage = "No articles found matching your criteria."
}) => {
  if (posts.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 px-4">
        <div className="w-16 h-16 rounded-2xl bg-sidebar flex items-center justify-center mb-6">
          <Search className="w-8 h-8 text-muted-foreground" />
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">
          No articles found
        </h3>
        <p className="text-muted-foreground text-center max-w-md">
          {emptyMessage}
        </p>
      </div>
    );
  }

  // If showing featured, take the first post as featured
  const featuredPost = showFeatured ? posts[0] : null;
  const remainingPosts = showFeatured ? posts.slice(1) : posts;

  return (
    <div className="space-y-12">
      {/* Featured post */}
      {featuredPost && (
        <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
          <BlogPostCard post={featuredPost} featured />
        </div>
      )}

      {/* Post grid */}
      {remainingPosts.length > 0 && (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {remainingPosts.map((post, index) => (
            <div
              key={post.id}
              className="animate-in fade-in slide-in-from-bottom-4 duration-500"
              style={{ animationDelay: `${(index + 1) * 100}ms` }}
            >
              <BlogPostCard post={post} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlogGrid;
